const reviews = [
  {
    type: "text",
    name: "Emma Richardson",
    role: "Fashion Blogger, London",
    quote: "The Mulebuy spreadsheet completely changed how I shop online. I used to spend hours jumping between different sites — now everything is organized in one spreadsheet. The price comparison feature alone saves me so much time and money each month. Absolutely recommend it for European shoppers.",
  },
  {
    type: "text",
    name: "Marco Verstappen",
    role: "Regular Shopper, Amsterdam",
    quote: "I was skeptical at first about using a spreadsheet for shopping, but the Mulebuy spreadsheet system is surprisingly intuitive. All 14 categories are clearly laid out, and I can quickly scan through products without the usual website clutter. Great for anyone who values efficiency.",
  },
  {
    type: "photo",
    name: "Sophie Laurent",
    role: "Style Enthusiast, Paris",
    image: "https://readdy.ai/api/search-image?query=Elegant%20French%20woman%20in%20her%20late%20twenties%20with%20wavy%20auburn%20hair%20wearing%20a%20cream%20linen%20blouse%2C%20sitting%20at%20a%20sidewalk%20cafe%20in%20Paris%20with%20soft%20bokeh%20background%2C%20warm%20golden%20hour%20light%2C%20candid%20editorial%20portrait%2C%20sophisticated%20natural%20expression%2C%20European%20lifestyle%20photography&width=400&height=500&seq=review-sophie-v2&orientation=portrait",
  },
  {
    type: "text-wide",
    name: "James Whitfield",
    role: "Tech Reviewer, Manchester",
    quote: "As someone who reviews shopping tools and platforms professionally, I can say the Mulebuy spreadsheet method is genuinely innovative. The structured spreadsheet approach brings transparency to pricing and product discovery that most platforms lack. The 14-category organization covers everything from Shoes to Accessories comprehensively. It has become my go-to recommendation for anyone looking to streamline their online shopping workflow.",
  },
  {
    type: "text-small-top",
    name: "Lena Mueller",
    role: "Student Shopper, Berlin",
    quote: "Finding good deals as a student is essential, and the Mulebuy spreadsheet makes that so much easier.",
  },
  {
    type: "text-small-bottom",
    name: "Thomas Andersen",
    role: "Deal Hunter, Copenhagen",
    quote: "The spreadsheet tracking system helps me monitor prices across weeks — it is a game changer for bargain hunting.",
  },
];

export default function FAQReviews() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-secondary-100 text-secondary-700 px-3 py-1 rounded-full text-xs font-medium mb-4">
            <i className="ri-chat-quote-line"></i>
            FAQ &amp; Reviews
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            What Buyers Say About Mulebuy Spreadsheet
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="space-y-5">
            <div className="bg-background-50 rounded-lg p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center text-secondary-700 font-semibold text-sm">ER</div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{reviews[0].name}</p>
                  <p className="text-xs text-foreground-500">{reviews[0].role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-3xl text-secondary-300 block mb-3"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{reviews[0].quote}</p>
            </div>

            <div className="bg-background-50 rounded-lg p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center text-accent-700 font-semibold text-sm">LM</div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{reviews[4].name}</p>
                  <p className="text-xs text-foreground-500">{reviews[4].role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-3xl text-accent-300 block mb-3"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{reviews[4].quote}</p>
            </div>
          </div>

          <div className="space-y-5">
            <div className="bg-background-50 rounded-lg p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-200 flex items-center justify-center text-primary-700 font-semibold text-sm">MV</div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{reviews[1].name}</p>
                  <p className="text-xs text-foreground-500">{reviews[1].role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-3xl text-primary-300 block mb-3"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{reviews[1].quote}</p>
            </div>

            <div className="bg-background-50 rounded-lg p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center text-secondary-700 font-semibold text-sm">TA</div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{reviews[5].name}</p>
                  <p className="text-xs text-foreground-500">{reviews[5].role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-3xl text-secondary-300 block mb-3"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{reviews[5].quote}</p>
            </div>
          </div>

          <div className="space-y-5">
            <div className="relative rounded-lg overflow-hidden h-56">
              <img
                src={reviews[2].image}
                alt={reviews[2].name}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-5">
                <p className="text-sm font-semibold text-background-50">{reviews[2].name}</p>
                <p className="text-xs text-background-50/80">{reviews[2].role}</p>
              </div>
            </div>

            <div className="relative rounded-lg overflow-hidden h-[calc(100%-14rem)] min-h-[220px]">
              <img
                src="https://readdy.ai/api/search-image?query=Confident%20British%20man%20in%20his%20early%20thirties%20with%20short%20brown%20hair%20wearing%20a%20navy%20blazer%20over%20a%20white%20shirt%2C%20standing%20in%20a%20modern%20book%20filled%20study%20with%20warm%20ambient%20lighting%2C%20intellectual%20editorial%20portrait%2C%20genuine%20thoughtful%20expression%2C%20refined%20professional%20photography&width=400&height=600&seq=review-james-v2&orientation=portrait"
                alt={reviews[3].name}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-5">
                <p className="text-sm font-semibold text-background-50">{reviews[3].name}</p>
                <p className="text-xs text-background-50/80">{reviews[3].role}</p>
                <p className="mt-2 text-xs text-background-50/90 leading-relaxed line-clamp-4">{reviews[3].quote}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}